import { useMemo } from 'react'
import { useQuery } from 'urql'
import { TimeClockTaskScope } from '../../gql/graphql'
import { GetTimeClockTasksQuery } from '../../graphql/timeclock'

export type TimeClockTask = {
  id: number
  name: string
  isNoteRequired: boolean
  noteRequired: string | null
  isGeoRequired: boolean
  geoRequired: string | null
  payable: boolean
  sort: number
}

/**
 * Available time clock tasks (active, operator scope). Variables must stay
 * STABLE — a per-mount `asOf` broke the offline cache key (CRE-80); the API
 * defaults the note/geo evaluation to "now".
 */
export const useTimeClockTasks = (options?: { pause?: boolean }) => {
  const [result] = useQuery({
    query: GetTimeClockTasksQuery,
    pause: options?.pause,
    variables: {
      where: {
        active: { equals: true },
        scopes: { has: TimeClockTaskScope.Operator },
      },
    },
  })

  const tasks = useMemo(() => {
    const raw = result.data?.timeClockTasks ?? []
    return [...raw].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
  }, [result.data])

  return {
    tasks,
    loading: result.fetching,
    error: result.error,
  }
}
